module.exports = require('./Time');



// WEBPACK FOOTER //
// ./lib/components/time/index.js